import {Severity} from '@mojility/coach-core';

const SignupFinalizeController = function ($routeParams, $scope, $location, localize, eventsService, accountGateway) {
  const $ctrl = this;

  // onInit
  $ctrl.localize = localize;

  $ctrl.password = '';
  $ctrl.name = '';

  accountGateway.checkCreationToken($routeParams.token)
    .catch(err => {
      $scope.$applyAsync(() => {
        $location.path('/');
      });
    });

  $ctrl.submit = function () {
    if($ctrl.submitIsDisabled()){
      eventsService.publishSystemError('Invalid inputs, please check your data and try again');
      return Promise.reject();
    }

    return accountGateway.completeAccountCreation({
      token: $routeParams.token,
      name: $ctrl.name,
      phone: $ctrl.phone,
      password: $ctrl.password
    })
      .then(() => {
        $scope.$applyAsync(() => {
          eventsService.publishSystemMessage($ctrl.localize.string('account_finalize','complete'));
          $location.path('/');
        })
      })
      .catch(error => {
        if (error.severity === Severity.ERROR)
          eventsService.publishSystemError(error.message);
        else
          eventsService.publishSystemMessage(error.message);
        $scope.$digest();
      })
  };

  $ctrl.submitIsDisabled = function () {
    return $ctrl.password !== $ctrl.confirmation || $ctrl.password.length < 5 || $ctrl.name === '';
  };
};

export default {
  name: 'SignupFinalizeController',
  fn: SignupFinalizeController
};
